import React from 'react';

import { Text } from '@reckon-web/text';

// ActivityCategory SignOffRevoke = 12
export const ActivityCategorySignOffRevoke = () => (
  <Text size="small">Revoked sign off</Text>
);
